<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 16px; margin-bottom: 0px"
          >
            权证管理
          </div>
        </a-space>
        <a-button type="primary" style="float: right;">新增权证</a-button>
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="提交时间">
            <a-range-picker style="width: 250px" :placeholder="['开始日期','结束日期']"/>
          </a-form-item>

          <a-form-item label="审核状态">
            <a-select default-value="全部" style="width: 160px">
              <a-select-option value="all">全部</a-select-option>
              <a-select-option value="pass">审核通过</a-select-option>
              <a-select-option value="pending">审核中</a-select-option>
              <a-select-option value="fail">审核不通过</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="权证编号">
            <a-input-search placeholder="权证编号" style="width: 220px" />
          </a-form-item>

          <br/>
          <div style="margin-top: 4px;">
            <a-form-item label="权证地址" >
              <a-input-search placeholder="权证地址" style="width: 250px" />
            </a-form-item>
            <a-form-item label="权利人名称">
              <a-input-search placeholder="权利人名称" style="width: 250px" />
            </a-form-item>

            <a-button type="primary" style="margin-top: 5px;">重置</a-button>
          </div>
          
        </a-form>
      </div>

      <a-table :columns="columns" :data-source="data" rowKey="id" :scroll="{ x: 1200}">
        <span slot="operation">
          <a style="color: #1890ff;">更新</a>
          <a-divider type="vertical" />
          <a @click="changeToDetail(1)" style="color: #1890ff;">详情</a>
          <a-divider type="vertical" />
          <a style="color: #1890ff;">删除</a>
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: '序号', dataIndex: 'index',width: 80, key: 'index' },
        { title: '权证编号', dataIndex: 'certificateNumber',width: 280, key: 'certificateNumber' },
        { title: '权证类型', dataIndex: 'certificateType',width: 100, key: 'certificateType' },
        { title: '权证地址', dataIndex: 'certificateAddress',width: 220, key: 'certificateAddress' },
        { title: '权利人名称', dataIndex: 'holderName',width: 220, key: 'holderName' },
        { title: '状态', dataIndex: 'status',width: 180, key: 'status' },
        { title: '提交时间', dataIndex: 'submitTime',width: 200, key: 'submitTime' },
        { title: '操作', key: 'operation',width: 180, fixed: 'right',scopedSlots: { customRender: 'operation' } },
      ],
      data: [
        {
          id: '1',
          index: 1,
          certificateNumber: '沪（2017）金字不动产权第016409号',
          certificateType: '产权',
          certificateAddress: '金山区亭林镇李伟公路2115号',
          holderName: '上海市金山区米泾供销合作社',
          status: '审核通过',
          submitTime: '2025-05-29 14:00',
        },
        {
          id: '2',
          index: 2,
          certificateNumber: '无证',
          certificateType: '其他',
          certificateAddress: '上海市金山区亭林镇南亭公路5858号',
          holderName: '上海金山商业发展（集团）有限公司',
          status: '审核通过',
          submitTime: '2025-05-15 16:11',
        },
        {
          id: '3',
          index: 3,
          certificateNumber: '沪房地金字（2011）第010896号',
          certificateType: '产权',
          certificateAddress: '浦泾镇中心街109、111号',
          holderName: '上海金山城镇商业经济联合社',
          status: '审核不通过',
          submitTime: '2024-12-15 16:30',
        },
      ],
    };
  },
  methods: {
    changeToDetail(val) {
      this.$emit('changeToDetail',{
        test:val
      })
    },
  },
};
</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input{
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
